var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showFilters,
          expression: "showFilters"
        }
      ],
      attrs: { sm8: "", md8: "" }
    },
    [
      _c(
        "FormFieldsContainer",
        [
          _vm.categoriaUsuario === "Interno"
            ? _c(
                "v-flex",
                { attrs: { sm4: "", md4: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      label: _vm.formFields.empresa.label,
                      items: _vm.listaEmpresas,
                      "item-text": "nombre",
                      "item-value": "id"
                    },
                    on: { change: _vm.searchDataEmpresa },
                    model: {
                      value: _vm.formFields.empresa.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.empresa, "value", $$v)
                      },
                      expression: "formFields.empresa.value"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-flex",
            { attrs: { sm4: "", md4: "" } },
            [
              _c("v-select", {
                attrs: {
                  label: _vm.formFields.estado.label,
                  items: _vm.listaEstados,
                  "item-text": "nombre",
                  "item-value": "id"
                },
                model: {
                  value: _vm.formFields.estado.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.estado, "value", $$v)
                  },
                  expression: "formFields.estado.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm4: "", md4: "" } },
            [
              _c("v-combobox", {
                attrs: {
                  items: _vm.activos,
                  label: _vm.formFields.patente.label,
                  "item-text": "nombre",
                  "item-value": "id",
                  dense: ""
                },
                on: { change: _vm.patenteBlur },
                model: {
                  value: _vm.formFields.patente.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.patente, "value", $$v)
                  },
                  expression: "formFields.patente.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm4: "", md4: "" } },
            [
              _c("DatePicker", {
                attrs: { label: _vm.formFields.fechaInicio.label },
                model: {
                  value: _vm.formFields.fechaInicio.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.fechaInicio, "value", $$v)
                  },
                  expression: "formFields.fechaInicio.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm4: "", md4: "" } },
            [
              _c("DatePicker", {
                attrs: { label: _vm.formFields.fechaFin.label },
                model: {
                  value: _vm.formFields.fechaFin.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.fechaFin, "value", $$v)
                  },
                  expression: "formFields.fechaFin.value"
                }
              })
            ],
            1
          ),
          _c("v-flex", { attrs: { sm4: "", md4: "" } }, [
            _c(
              "div",
              { staticClass: "text-sm-center botones-filtros" },
              [
                _c(
                  "v-btn",
                  { on: { click: _vm.handleBuscarClick } },
                  [
                    _c("v-icon", [_vm._v("search")]),
                    _vm._v("Filtrar\n        ")
                  ],
                  1
                ),
                _c(
                  "v-btn",
                  { on: { click: _vm.clearFilters } },
                  [_c("v-icon", [_vm._v("clear")]), _vm._v("Limpiar ")],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }